<template>
  <div>
    <component v-show="isInit" :is="layout"></component>
    <div class="ajax-loading" :class="isAjaxLoading ? '' : 'd-none'"><img src="@/assets/image/ajax_loading.gif"></div>
  </div>
</template>

<script>
import NormalLayout from '@/components/layouts/NormalLayout';
import TitleLayout from '@/components/layouts/TitleLayout';
import NoHeaderLayout from '@/components/layouts/NoHeaderLayout';
import CopyrightLayout from '@/components/layouts/CopyrightLayout';
import {mapState} from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      isInit: false,
      isAjaxLoading: false,
    }
  },
  components: {NoHeaderLayout, NormalLayout, TitleLayout, CopyrightLayout},
  created () {
    this.checkAppVersion()
  },
  mounted () {
    this.$eventBus.$on('apiError', this.onApiError)
    this.$eventBus.$on('showAjaxLoading', this.onShowAjaxLoading)
  },
  updated () {
    this.isInit = true;
  },
  beforeDestroy () {
    this.$eventBus.$off('apiError')
    this.$eventBus.$off('showAjaxLoading', this.onShowAjaxLoading)
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || 'normal') + '-layout';
    },
    pageTitle () {
      return (this.$route.meta && this.$route.meta.pageTitle) ? this.$t(this.$route.meta.pageTitle) : this.$t('common.page_title');
    },
    ...mapState({
      appVersion: state => state.appVersion,
      hideContent: state => state.hideContentByAppVersion
    })
  },
  methods: {
    onApiError (response) {
      let errMsg = '';
      if (response.data && response.data.error_message) {
        errMsg = response.data.error_message
      } else {
        if (navigator.onLine) {
          errMsg = this.$t('common.server_error')
        } else {
          errMsg = this.$t('common.network_error')
        }
      }
      alert(errMsg)
    },
    onShowAjaxLoading (value) {
      this.isAjaxLoading = !!value
    },
    async checkAppVersion () {
      await this.$store.dispatch('checkAppVersion');
    }
  },
  watch: {
    $route: function () {
      // document.title = this.pageTitle;
    },
    async appVersion (val) {
      if (val) {
        this.checkAppVersion()
      }
    }
  }
}
</script>
<style src="@/assets/css/reset.css"></style>
<style src="@/assets/css/common.css"></style>
<style src="@/assets/css/style.css"></style>



// WEBPACK FOOTER //
// src/App.vue